export default "__VITE_ASSET__BK1CIuyT__"